import _ from 'underscore'
import TestViewTemplate from '../../../templates/test.tpl'
import config from '../../../config'
import TestView from '../../../views/test'

const Maks2TestView = TestView.extend({
    initialize() {
        this.template = _.template(TestViewTemplate)

        // reset the test model
        this.model.get('test').reset()

        // set the mode
        this.model.set('mode', 'test')

        // create methodology and problem question arrays
        const questions = this.model.get('question_list')
        const methodology = questions.filter(q => q.question_list[0].tag === 'm')
        const problem = questions.filter(q => q.question_list[0].tag === 'p')

        // find their lengths
        // if there are no problem-solving questions pick 5 methodology questions
        // otherwise pick 3 methodology and 2 problem-solving questions
        const numMethodology = problem.length === 0 ? Math.min(5, methodology.length) : Math.min(3, methodology.length)
        const numProblem = Math.min(2, problem.length)

        // pick random questions
        const randomMethodology = _.sample(methodology, numMethodology)
        const randomProblem = _.sample(problem, numProblem)

        const randomQuestions = config.get('testMode') ? questions : randomMethodology.concat(randomProblem)

        // load them into the test model
        this.model.get('test').set({
            questions: randomQuestions,
            start_timestamp: new Date().getTime(),
        })

        // if this model changes it means the user has answered so show
        // the next question button AND explanation
        this.listenTo(this.model.get('test'), 'change', this.questionAnswered)
    }
})

export default Maks2TestView
